<script setup lang="ts">
import { router, usePage } from '@inertiajs/vue3'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const page = usePage()

const impersonating = computed(() => page.props.auth.impersonating)

const leave = () => {
  if (!impersonating.value) {
    return
  }

  router.post(impersonating.value.leaveUrl)
}
</script>

<template>
  <aside v-if="impersonating" class="border-warning-200 bg-warning-subtle mx-2 overflow-hidden rounded-lg border">
    <div class="bg-warning-400 h-0.5" />
    <div class="flex flex-col gap-2 p-4">
      <div class="flex items-center gap-2">
        <i class="pi pi-user-edit text-warning-700 text-sm" aria-hidden="true" />
        <span class="text-warning-900 text-sm font-semibold">{{ t('title') }}</span>
      </div>
      <span class="text-warning-900 truncate text-sm">{{ impersonating.name }}</span>
      <Button severity="warn" size="small" outlined :label="t('leave')" @click="leave" />
    </div>
  </aside>
</template>

<i18n>
{
  "de": {
    "title": "Impersonation aktiv",
    "leave": "Impersonation beenden"
  },
  "en": {
    "title": "Impersonation active",
    "leave": "Stop impersonation"
  }
}
</i18n>
